module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1b16bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/Products.vue
// module id = 507
// module chunks = 0